import React from 'react';
export function CalendarSection() {
  return <section className="py-16 md:py-24 bg-brand-black" data-id="element-849">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-850">
        <div className="w-full aspect-[4/3] md:aspect-[16/9] lg:h-[700px] border border-brand-gray-800 bg-brand-gray-900 p-2" data-id="element-851">
          <iframe src="https://www.google.com/calendar/embed?src=jmedinaapc%40gmail.com&ctz=America/New_York&bgcolor=%23111827&color=%23009DD0&showTitle=0" style={{
          border: 0,
          width: '100%',
          height: '100%'
        }} frameBorder="0" scrolling="yes" title="Training Calendar" data-id="element-852" />
        </div>
      </div>
    </section>;
}